export const CARE_SECTION_KEYS = [
  "BEFORE_WEARING",
  "AFTER_WEARING",
  "CLEANING",
  "STORAGE",
  "STAIN_ACCIDENT",
  "LONG_TERM_PRESERVATION",
] as const;

export type CareSectionKey = (typeof CARE_SECTION_KEYS)[number];
export type CareLang = "en" | "hi";
export type CareText = { en?: string | null; hi?: string | null };
export type CareSections = Partial<Record<CareSectionKey, CareText>>;

export type CareTemplate = {
  id: string;
  name: string;
  source: "GLOBAL" | "STUDIO";
  status: "ACTIVE" | "ARCHIVED";
  version: number;
  editable: boolean;
  duplicatedFromId?: string | null;
  updatedAt?: string;
  sections: CareSections;
  usedOnProducts: number;
};

export type ResolvedSection = { key: CareSectionKey; en?: string | null; hi?: string | null };

/** What a buyer sees: from the certificate response, or `resolved` in the studio preview. */
export type ResolvedCare = { sections: ResolvedSection[]; additionalNotes?: CareText | null };

export type ProductCareProfile = {
  version: number;
  templateId: string;
  templateName: string;
  templateSource: "GLOBAL" | "STUDIO";
  templateVersion: number;
  templateSnapshot: CareSections;
  overrides: CareSections;
  additionalNotes?: CareText | null;
  updatedAt?: string;
  templateArchived: boolean;
  latestTemplateVersion?: number | null;
  updateAvailable: boolean;
};

export type ProductCare = {
  productUniqueId: string;
  profile: ProductCareProfile | null;
  resolved: ResolvedCare | null;
};

export type ApplyState = "CURRENT" | "OUTDATED" | "OTHER" | "NONE" | "NOT_FOUND";
export type ApplyResult = { productUniqueId: string; result: "APPLIED" | "UNCHANGED" | "NOT_FOUND" | "CONFLICT" | "CARE_EMPTY"; overridesCleared?: boolean };

export type CareEnvelope<T> = { success: boolean; message?: string; code?: string; status?: number; data?: T };
